import { graphql } from 'parkdepot-shared/gql'

const B2C_GET_LOT_BY_ID = graphql(`
    query B2CGetLotById($lot_id: String!) {
        b2c_get_carpay_lot(lot_id: $lot_id) {
            lot {
                lot_id
                name
                address
                lot_type
                lot_tariffs
                sv_lot_type
                discount_types
                longitude
                latitude
            }
            parking_contexts {
                uuid
                vehicle_type
            }
        }
    }
`)

export default B2C_GET_LOT_BY_ID
